import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { createIncomeStatement, fetchReportIncomeStatement, setReportsFilters, updateIncomeStatement } from '../../action';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import { fetchArticlesCash, fetchArticlesCashCategories, fetchArticlesExpenditures, fetchFilials, fetchPayments, fetchSources } from '../../action/handbook';
import { defaultPlatforms, roleId } from '../../constants/app';
import ErrorContainer from '../utils/ErrorContainer';
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import { fetchSettings } from '../../action/app';
import ExcelJS from 'exceljs';
import swal from 'sweetalert';

const ruNominative = {
    ...ru,
    localize: {
        ...ru.localize,
        month: (n) => {
            const months = [
                'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
                'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
            ];
            return months[n];
        },
        monthAbbr: (n) => {
            const monthsAbbr = [
                'янв', 'фев', 'мар', 'апр', 'май', 'июн',
                'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'
            ];
            return monthsAbbr[n];
        }
    }
};

registerLocale("ruNominative", ruNominative);

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

const calculatePercent = (value1, value2) => {
    if (!value1 || !value2) return 0;
    return parseNumToFixed((value1 / value2) * 100);
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const getDetailLabel = (detail) => {
    if (!detail || !detail.value) return;
    if (detail.value === 'source') return 'detailItemsSource';
    if (detail.value === 'payment') return 'detailItemsPayments';
    if (detail.value === 'delivery') return 'detailItemsDelivery';
    return;
}

function OpenableRow({item, detail, color='#d5d4ff61', marginLeft = '0px', leftArrow = '10px', divider = null}) {
    const [ showDetail, setShowDetail ] = useState(false);
    const resultDivider = +divider || +item.divider || 0;

    const detailLabel = getDetailLabel(detail);
    const detailItems = detailLabel ? item[detailLabel] || item.detailItems : item.detailItems;
    const renderDetail = !isEmpty(detailItems);

    const handleClick = () => {
        if (!renderDetail) return;
        setShowDetail(!showDetail);
    }

    return (
    <>
        <tr onClick={handleClick} className='kt-datatable__row' style={renderDetail ? { cursor: 'pointer', backgroundColor: item.color ? item.color : color } : { backgroundColor: item.color ? item.color : color }}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}>{renderDetail ? <i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ position: 'absolute', left: leftArrow, marginTop: '0.4rem', fontSize: '0.8rem' }}/> : ''}<span style={{ marginLeft: marginLeft }}>{item.name || '-'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(parseNumToFixed(item.sum)) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{resultDivider > 0 ? calculatePercent(item.sum, resultDivider) + ' %' : ''}</span></td>
        </tr>
        {renderDetail && showDetail && 
            Object.values(detailItems).map((detailItem) => detailItem.openable ? <OpenableRow item={detailItem} detail={detail} divider={detailItem.divider || resultDivider} color={color === '#d5d4ff61' ? '#bbbaff61' : '#d5d4ff61'} leftArrow={`${(parseInt(leftArrow) || 0) + 15}px`} marginLeft={`${(parseInt(marginLeft) || 0) + 15}px`} /> : <ItemRow item={detailItem} divider={detailItem.divider || resultDivider} marginLeft={`${(parseInt(marginLeft) || 0) + 15}px`} color={color === '#d5d4ff61' ? '#bbbaff61' : '#d5d4ff61'}/>)
        }
    </>
    );
}

function ItemRow({item, color='#d5d4ff61', marginLeft = '0px', divider = null}) {
    const resultDivider = +divider || +item.divider || 0;

    return (
    <>
        <tr className='kt-datatable__row' style={{ backgroundColor: item.color ? item.color : color }}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={{ marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(parseNumToFixed(item.sum)) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{resultDivider > 0 ? calculatePercent(item.sum, resultDivider) + ' %' : ''}</span></td>
        </tr>
    </>
    );
}

const detailOptions = [
    { value: 'source', label: 'Источник' },
    { value: 'payment', label: 'Способ оплаты' },
    { value: 'delivery', label: 'Тип доставки' },
];

const defaultPayments = [
    { label: 'Без оплаты', value: null },
    { label: 'Наличные', value: 'cash' },
    { label: 'Терминал', value: 'terminal' },
    { label: 'ЮКасса', value: 'online' },
    { label: 'Яндекс', value: 'YE' },
    { label: 'Деливери', value: 'DC' },
];

export default function IncomeStatement() {
    const data = useSelector(state => state.reports.incomeStatement);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const sources = useSelector(state => state.handbook.sources);
    const sourcesCount = useSelector(state => state.handbook.count.sources);
    const sourcesLoader = useSelector(state => state.loaders.sources);
    const payments = useSelector(state => state.handbook.payments);
    const paymentsCount = useSelector(state => state.handbook.count.payments);
    const paymentsLoader = useSelector(state => state.loaders.payments);
    const settings = useSelector(state => state.settings.init);
    const settingsLoader = useSelector(state => state.loaders.settings)
    const entityArticlesCash = useSelector(state => state.handbook.articlesCash);
    const articlesLoader = useSelector(state => state.loaders.articlesCash);
    const articlesCashCategories = useSelector(state => state.handbook.articlesCashCategories);
    const categoriesLoader = useSelector(state => state.loaders.articlesCashCategories);
    const articlesExpenditures = useSelector(state => state.handbook.articlesExpenditures);
    const expendituresLoader = useSelector(state => state.loaders.articleExpenditures);
    const loader = pointLoading || sourcesLoader || settingsLoader || articlesLoader || categoriesLoader || expendituresLoader || paymentsLoader;
    const user = useSelector(state => state.user.info);

    const { result, orders, workingShifts, otherExpenditures, filters, loading } = data;
    const [ renderFilters, setRenderFilters ] = useState(filters);
    const [ platforms, setPlatforms] = useState(defaultPlatforms);
    const [ detail, setDetail ] = useState(detailOptions[0]);
    const [ resultPayments, setResultPayments ] = useState(defaultPayments);
    const force = useRef(false);
    const [ reportId, setReportId ] = useState(null);
    const actualCommissions = useRef(false);

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async () => {
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
            if (isEmpty(settings)) await dispatch(fetchSettings());
            if (isEmpty(sources) || sources.length < sourcesCount) await dispatch(fetchSources(true));
            if (isEmpty(payments) || payments.length < paymentsCount) await dispatch(fetchPayments(true));
            await dispatch(fetchArticlesCash(true));
            await dispatch(fetchArticlesExpenditures(true))
            await dispatch(fetchArticlesCashCategories(true))
        };
        
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        if (!isEmpty(sources)) setPlatforms(sources);
    }, [sources]);

    useEffect(() => {
        if (!isEmpty(payments)) {
            const dataPayments = [ ...defaultPayments ];
            payments.forEach((payment) => {
                const isDuplicate = dataPayments.some(item => item.value === payment.Name);
                if (!isDuplicate) dataPayments.push({ label: payment.VisibleName, value: payment.Name });
            });
            setResultPayments(dataPayments);
        }
    }, [payments]);

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('incomeStatement', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportIncomeStatement());
        setRenderFilters(filters);
    }

    const sendData = (data) => {
        if (!isEmpty(result) && !force.current) return;
    
        const { revenue, revenueAgg, aggCommission } = data;
        const sendedData = { pointId: renderFilters.point.value, month: moment(renderFilters.month).toISOString(), revenue, revenueAgg, aggCommission };
    
        if (force.current && !isEmpty(result) && reportId) {
            dispatch(updateIncomeStatement(sendedData, reportId));
            force.current = false;
            actualCommissions.current = false;
            setReportId(null);
        } 
        else if (isEmpty(result)) {
            dispatch(createIncomeStatement(sendedData));
            setReportId(null);
            force.current = false;
            actualCommissions.current = false;
        }
    };

    const isDisabledSearch = () => {
        if (loading) return true;
        if (!filters.point || !filters.month) return true;
        return false;        
    }

    const getGroupedData = () => {
        const { articlesCash } = settings;
        const { 
            sale,
            kporogu,
            otherCommissionAgg,
            acquiringTerminal,
            acquiringYookassa,
            taxes,
            incasso,
            banking,
        } = articlesCash;

        let revenue = { name: 'Выручка', openable: true, sum: 0, detailItems: {}, detailItemsPayments: {}, detailItemsSource: {}, detailItemsDelivery: {} };
        let getRevenue = true;
        
        let revenueAgg = { name: 'Выручка агрегатора (Общая)', openable: true, sum: 0, detailItems: {}, detailItemsPayments: {}, detailItemsSource: {}, detailItemsDelivery: {} };
        let getRevenueAgg = true;

        let aggCommission = { name: 'Комиссия Агрегаторы', openable: true, sum: 0, detailItems: {} };
        let getAggCommisiion = true;

        if (!force.current && !isEmpty(result)) {
            if (!isEmpty(result.revenue)) {
                revenue = result.revenue;
                getRevenue = false;
            }
            
            if (!isEmpty(result.revenueAgg)) {
                revenueAgg = result.revenueAgg;
                getRevenueAgg = false;
            }

            if (!isEmpty(result.aggCommission)) {
                aggCommission = result.aggCommission;
                getAggCommisiion = false;
            }
        }
        

        const totalRevenue = { name: 'Выручка от реализации (Общая)', openable: true, sum: 0 };
        const otherIncome = { name: 'Прочие доходы', openable: true, sum: 0, detailItems: { 'Возвраты по кассовым статьям изъятия': { name: 'Возвраты по кассовым статьям изъятия', sum: 0 }, 'Возвраты по оплаченным накладным': { name: 'Возвраты по оплаченным накладным', sum: 0 }, 'Продажи побочного товара': { name: 'Продажи побочного товара', sum: 0, openable: true, detailItems: {} } }};
        
        const invoicesPayments = { name: 'Оплата накладных', sum: 0 };

        const labelsRevenueSource = ['КЦ', 'Сайт', 'Приложение', 'Филиал (магазин)', 'CRM. Принадлежность роли не определена'];
        const aggLabelsRevenueSource = [];
        const aggLabelsRevenuePayment = [];
        const commissionLabels = [];
        const labelsRevenuePayment = [];
        const aggLabelsRevenueDelivery = [ 'Доставка', 'Вынос' ];
        const labelsRevenueDelivery = [ 'Доставка', 'Вынос' ];

        platforms.forEach((source) => {
            if (source && source.name) {
                if (source.isAggregator) {
                    aggLabelsRevenueSource.push(source.name);
                    commissionLabels.push(source.name);
                } else {
                    labelsRevenueSource.push(source.name);
                }
            }
        });

        resultPayments.forEach((payment) => {
            aggLabelsRevenuePayment.push(payment.label);
            labelsRevenuePayment.push(payment.label);
        });

        labelsRevenueSource.push('Источник не определен');

        if (getRevenue) {
            labelsRevenueSource.forEach((label) => {
                revenue.detailItemsSource[label] = { name: label, sum: 0 };
            });

            labelsRevenuePayment.forEach((label) => {
                revenue.detailItemsPayments[label] = { name: label, sum: 0 };
            });

            labelsRevenueDelivery.forEach((label) => {
                revenue.detailItemsDelivery[label] = { name: label, sum: 0 };
            });
        }

        if (getRevenueAgg) {
            aggLabelsRevenueSource.forEach((label) => {
                revenueAgg.detailItemsSource[label] = { name: label, sum: 0 };
            });

            aggLabelsRevenuePayment.forEach((label) => {
                revenueAgg.detailItemsPayments[label] = { name: label, sum: 0 };
            });

            aggLabelsRevenueDelivery.forEach((label) => {
                revenueAgg.detailItemsDelivery[label] = { name: label, sum: 0 };
            });
        }

        if (getAggCommisiion) commissionLabels.forEach((label) => {
            aggCommission.detailItems[label] = { name: label, sum: 0 };
        });

        if (getAggCommisiion) aggCommission.detailItems['Пополнение баланса КПорогу'] = { name: 'Пополнение баланса КПорогу', sum: 0 };

        const controlledOperatingExpenses = { name: 'Контролируемые операционные расходы', openable: true, sum: 0, detailItems: {} }; 
        const uncontrolledOperatingExpenses = { name: 'Неконтролируемые операционные расходы', openable: true, sum: 0, detailItems: {} }; 
        const refundSale = { name: 'Возвраты по кассовым статьям внесения от продажи', openable: true, sum: 0, detailItems: {} };

        const controlledOperatingArticlesCategoriesIds = articlesCashCategories.filter((category) => !!category.controlled).map((category) => +category.id).filter((item) => item);
        const uncontrolledOperatingArticlesCategoriesIds = articlesCashCategories.filter((category) => !!category.uncontrolled).map((category) => +category.id).filter((item) => item);
        
        const getDetailItemsOperatingArticlesCategories = (categoryId) => {
            const result = {};
            if (!categoryId) return result;

            const filteredArticles = entityArticlesCash.filter((article) => {
                if (!article || !article.category) return false;
                const articleCategory = article.category.id ? article.category.id : article.category;
                if (!articleCategory) return false;
                if (articleCategory === categoryId) return true;
                return false;
            });

            filteredArticles.forEach((article) => {
                result[article.name] = { name: article.name, sum: 0 };
            });

            return result;
        }
        
        const taxesData = { name: 'Налоги', openable: true, sum: 0, detailItems: getDetailItemsOperatingArticlesCategories(taxes) };
        const incassoData = { name: 'Инкассация', openable: true, sum: 0, detailItems: getDetailItemsOperatingArticlesCategories(incasso) };

        articlesCashCategories.forEach((category) => {
            if (controlledOperatingArticlesCategoriesIds.length > 0 && controlledOperatingArticlesCategoriesIds.includes(category.id)) controlledOperatingExpenses.detailItems[category.name] = { name: category.name, sum: 0, openable: true, detailItems: getDetailItemsOperatingArticlesCategories(category.id) };
            if (uncontrolledOperatingArticlesCategoriesIds.length > 0 && uncontrolledOperatingArticlesCategoriesIds.includes(category.id)) uncontrolledOperatingExpenses.detailItems[category.name] = { name: category.name, sum: 0, openable: true, detailItems: getDetailItemsOperatingArticlesCategories(category.id) };
        });

        const getBankingDetailItems = () => {
            if (!banking || isEmpty(articlesExpenditures)) return {};
            const entityArticleBanking = articlesExpenditures.find((article) => +article.id === +banking);
            return { [entityArticleBanking.id]: { name: entityArticleBanking.name, sum: 0 }};
        }

        uncontrolledOperatingExpenses.detailItems['Банковские услуги (РКО)'] = { name: 'Банковские услуги (РКО)', sum: 0, openable: true, detailItems: getBankingDetailItems() };
        // controlledOperatingExpenses.detailItems['Фонд оплаты труда'] = { name: 'Фонд оплаты труда', sum: 0 };
        const calculateAggCommission = (totalPrice, commission, courierId) => {
            const calculateAggCommissionPercent = (sum, persent) => {
                if (!sum || !persent) return 0;
                return +parseNumToFixed(persent * 0.01 * sum);
            }

            if (commission.type === 'sum') {
                if (courierId) return +commission.sum;
                return +commission.sumAgg;
            }
            
            if (commission.type === 'persent') {
                if (courierId) return +calculateAggCommissionPercent(totalPrice, commission.persent);
                return +calculateAggCommissionPercent(totalPrice, commission.persentAgg);
            }

            if (commission.type === 'combined') {
                if (courierId) return +commission.sum + +calculateAggCommissionPercent(totalPrice, commission.persent);
                return +commission.sumAgg + +calculateAggCommissionPercent(totalPrice, commission.persentAgg);
            }
        }

        const getSourceOrder = (order) => {
            if (order.aggData && order.aggData.platform) {
                const platform = platforms.find((source) => source.value === order.aggData.platform);
                const result = { isAggregator: order.aggData.isAggregator || false, name: order.aggData.platform };
                if (!isEmpty(platform)) {
                    if (platform.name) result.name = platform.name;
                    if (platform.isAggregator) result.isAggregator = platform.isAggregator;
                    if (platform.commissions) {
                        const entityCommission = platform.commissions.find((commission) => commission.allPoints || commission.pointsIds.includes(+renderFilters.point.value));
                        if (!isEmpty(entityCommission)) result.commission = { sum: +entityCommission.sum || 0,  sumAgg: +entityCommission.sumAgg || 0, type: entityCommission.type, persent: +entityCommission.persent || 0, persentAgg: +entityCommission.persentAgg || 0 };
                    }
                }
                return result
            }

            if (order.source && order.source !== 'crm') {
                const platform = platforms.find((source) => source.value === order.source);
                if (platform && platform.name) return { isAggregator: platform.isAggregator || false, name: platform.name, commission: platform.commission };
            }

            if (order.source !== 'crm') {
                if (order.isSite) return { isAggregator: false, name: 'Сайт' };
                return { isAggregator: false, name: 'Приложение' };
            }
            
            if (order.source === 'crm') {
                if (order.authorRole) {
                    if ([roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC].includes(order.authorRole)) return { isAggregator: false, name: 'КЦ' };
                    if ([roleId.manager, roleId.cashier, roleId.regionalDirector].includes(order.authorRole)) return { isAggregator: false, name: 'Филиал (магазин)' };
                    if (![roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC, roleId.manager, roleId.cashier, roleId.operationDirector].includes(order.authorRole)) return { isAggregator: false, name: 'CRM. Принадлежность роли не определена' };
                }
            }
            
            return { isAggregator: false , name: 'Источник не определен' };
        }

        if (getRevenue || getRevenueAgg || getAggCommisiion) (orders || []).forEach((order) => {
            const sourceOrder = getSourceOrder(order);
            const paymentOrder = order.payment ? resultPayments.find((item) => item.value === order.payment) || { label: 'Без оплаты' } : { label: 'Без оплаты' };
            const delivery = order.deliveryMethod === 'delivery' ? 'Доставка' : 'Вынос';
            if (sourceOrder.isAggregator) {
                if (getRevenueAgg) {
                    revenueAgg.sum += +order.totalPrice || 0;
                    revenueAgg.detailItemsSource[sourceOrder.name].sum += +order.totalPrice || 0;
                    revenueAgg.detailItemsPayments[paymentOrder.label].sum += +order.totalPrice || 0;
                    revenueAgg.detailItemsDelivery[delivery].sum += +order.totalPrice || 0;
                }
                if (getAggCommisiion) {
                    if (!actualCommissions.current && !isEmpty(order.aggData) && !isEmpty(order.aggData.commission)) {
                        const commission = calculateAggCommission(order.totalPrice, order.aggData.commission, order.courierId);
                        aggCommission.detailItems[sourceOrder.name].sum += +commission || 0;
                        aggCommission.sum += +commission || 0;
                    } else if (!isEmpty(sourceOrder.commission)) {
                        const commission = calculateAggCommission(order.totalPrice, sourceOrder.commission, order.courierId);
                        aggCommission.detailItems[sourceOrder.name].sum += +commission || 0;
                        aggCommission.sum += +commission || 0;
                    }
                }
            } else {
                if (getRevenue) {
                    revenue.sum += +order.totalPrice || 0;
                    revenue.detailItemsSource[sourceOrder.name].sum += +order.totalPrice || 0;
                    revenue.detailItemsPayments[paymentOrder.label].sum += +order.totalPrice || 0;
                    revenue.detailItemsDelivery[delivery].sum += +order.totalPrice || 0;
                }
            }

            if (getRevenue || getRevenueAgg) totalRevenue.sum += +order.totalPrice || 0;
        });
        
        if (!getRevenue && !getRevenueAgg) totalRevenue.sum = (+revenue.sum || 0) + (+revenueAgg.sum || 0);

        for (const workingShift of (workingShifts || [])) {
            if (isEmpty(workingShift.articlesCashes)) continue;
            const articlesCashShift = JSON.parse(workingShift.articlesCashes);
            articlesCashShift.filter((article) => {
                if (!article.refund) return false;
                if (article.invoiceId || article.wageId) return false;
                if (article.typeMovementCash !== 'income') return false;
                return true;
            }).forEach((article) => {
                otherIncome.sum += +article.sum || 0;
                otherIncome.detailItems['Возвраты по кассовым статьям изъятия'].sum += +article.sum || 0;
                totalRevenue.sum += +article.sum || 0;
            });;

            if (sale) {
                const salesIds = entityArticlesCash.filter((item) => {
                    const categoryId = item.category ? item.category.id ? +item.category.id : +item.category : null;
                    if (categoryId && +sale === categoryId) return true;
                    return false;
                }).map((item) => item.id);

                articlesCashShift.filter((article) => {
                    if (article.invoiceId || article.wageId) return false;
                    if (salesIds.includes(+article.articleId)) return true;
                    return false;
                }).forEach((article) => {
                    if (article.typeMovementCash !== 'income') {
                        refundSale.sum += +article.sum || 0;
                        if (refundSale.detailItems[article.articleId]) {
                            otherIncome.detailItems[article.articleId].sum += +article.sum || 0;
                        } else {
                            const entityArticle = entityArticlesCash.find((item) => +item.id === article.articleId);
                            if (!isEmpty(entityArticle)) otherIncome.detailItems[article.articleId] = { name: entityArticle.name, sum: +article.sum || 0 }
                        }
                    } else {
                        otherIncome.sum += +article.sum || 0;
                        otherIncome.detailItems['Продажи побочного товара'].sum += +article.sum || 0;
                        
                        if (otherIncome.detailItems['Продажи побочного товара'].detailItems[article.articleId]) {
                            otherIncome.detailItems['Продажи побочного товара'].detailItems[article.articleId].sum += +article.sum || 0;
                        } else {
                            const entityArticle = entityArticlesCash.find((item) => +item.id === article.articleId);
                            if (!isEmpty(entityArticle)) otherIncome.detailItems['Продажи побочного товара'].detailItems[article.articleId] = { name: entityArticle.name, sum: +article.sum || 0 }
                        }
    
                        totalRevenue.sum += +article.sum || 0;
                    }
                    
                });
            }

            if (kporogu) {
                articlesCashShift.filter((article) => {
                    if (article.refund) return false;
                    if (article.invoiceId || article.wageId) return false;
                    if (article.typeMovementCash !== 'expenditure') return false;
                    if (+article.articleId === +kporogu) return true;
                    return false;
                }).forEach((article) => {
                    aggCommission.sum += +article.sum || 0;
                    aggCommission.detailItems['Пополнение баланса КПорогу'].sum += +article.sum || 0;
                });;
            }

            articlesCashShift.filter((article) => {
                if (!article.refund) return false;
                if (!article.invoiceId || article.wageId) return false;
                if (article.typeMovementCash !== 'income') return false;
                return true;
            }).forEach((article) => {
                otherIncome.sum += +article.sum || 0;
                otherIncome.detailItems['Возвраты по оплаченным накладным'].sum += +article.sum || 0;
                totalRevenue.sum += +article.sum || 0;
            });

            // articlesCashShift.filter((article) => {
            //     if (article.refund) return false;
            //     if (article.invoiceId || !article.wageId) return false;
            //     if (article.typeMovementCash !== 'expenditure') return false;
            //     return true;
            // }).forEach((article) => {
            //     controlledOperatingExpenses.detailItems['Фонд оплаты труда'].sum += +article.sum || 0;
            // });

            articlesCashShift.filter((article) => {
                if (article.refund) return false;
                if (!article.invoiceId || article.wageId) return false;
                if (article.typeMovementCash !== 'expenditure') return false;
                return true;
            }).forEach((article) => {
                invoicesPayments.sum += +article.sum || 0; 
            });

            articlesCashShift.forEach((article) => {
                const entityArticle = entityArticlesCash.find((item) => +item.id === article.articleId);
                if (entityArticle && entityArticle.category) {
                    if (entityArticle.category.id && entityArticle.category.name) {
                        if (article.typeMovementCash === 'expenditure' && controlledOperatingArticlesCategoriesIds.length > 0 && controlledOperatingArticlesCategoriesIds.includes(+entityArticle.category.id)) {
                            controlledOperatingExpenses.detailItems[entityArticle.category.name].sum += +article.sum || 0;

                            if (controlledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name]) {
                                controlledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name].sum += +article.sum || 0;
                            } else {
                                controlledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name] = { name: entityArticle.name, sum: +article.sum || 0 };
                            }

                            controlledOperatingExpenses.sum += +article.sum || 0;
                        }

                        if (article.typeMovementCash === 'expenditure' && uncontrolledOperatingArticlesCategoriesIds.length > 0 && uncontrolledOperatingArticlesCategoriesIds.includes(+entityArticle.category.id)) {
                            uncontrolledOperatingExpenses.detailItems[entityArticle.category.name].sum += +article.sum || 0;

                            if (uncontrolledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name]) {
                                uncontrolledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name].sum += +article.sum || 0;
                            } else {
                                uncontrolledOperatingExpenses.detailItems[entityArticle.category.name].detailItems[entityArticle.name] = { name: entityArticle.name, sum: +article.sum || 0 };
                            }

                            uncontrolledOperatingExpenses.sum += +article.sum || 0;
                        }
                        
                        if (article.typeMovementCash === 'expenditure' && taxes && +entityArticle.category.id === +taxes) {
                            taxesData.sum += +article.sum || 0;
                            if (taxesData.detailItems[entityArticle.name]) {
                                taxesData.detailItems[entityArticle.name].sum += +article.sum || 0;
                            } else {
                                taxesData.detailItems[entityArticle.name] = { name: entityArticle.name, sum: article.sum || 0 };
                            }
                        }
                        
                        if (incasso && +entityArticle.category.id === +incasso) {
                            if (article.typeMovementCash === 'expenditure') incassoData.sum -= +article.sum || 0;
                            if (article.typeMovementCash === 'income') incassoData.sum += +article.sum || 0;
                            if (incassoData.detailItems[entityArticle.name]) {
                                if (article.typeMovementCash === 'income') incassoData.detailItems[entityArticle.name].sum += +article.sum || 0;
                                if (article.typeMovementCash === 'expenditure') incassoData.detailItems[entityArticle.name].sum -= +article.sum || 0;
                            } else {
                                let sum = 0;
                                if (article.typeMovementCash === 'expenditure') sum -= +article.sum || 0;
                                if (article.typeMovementCash === 'income') sum += +article.sum || 0;
                                incassoData.detailItems[entityArticle.name] = { name: entityArticle.name, sum };
                            }
                        }
                    } else {
                        const categoryId = entityArticle.category ? entityArticle.category.id ? +entityArticle.category.id : +entityArticle.category : null;
                        if (categoryId) {
                            const entityCategory = articlesCashCategories.find((category) => +category.id === categoryId);
                            if (!isEmpty(entityCategory)) {
                                if (article.typeMovementCash === 'expenditure' && controlledOperatingArticlesCategoriesIds.length > 0 && controlledOperatingArticlesCategoriesIds.includes(+entityCategory.id)) {
                                    controlledOperatingExpenses.detailItems[entityCategory.name].sum += +article.sum || 0;

                                    if (controlledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name]) {
                                        controlledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name].sum += +article.sum || 0;
                                    } else {
                                        controlledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name] = { name: entityArticle.name, sum: +article.sum || 0 };
                                    }
                                    
                                    controlledOperatingExpenses.sum += +article.sum || 0;
                                }
        
                                if (article.typeMovementCash === 'expenditure' &&uncontrolledOperatingArticlesCategoriesIds.length > 0 && uncontrolledOperatingArticlesCategoriesIds.includes(+entityCategory.id)) {
                                    uncontrolledOperatingExpenses.detailItems[entityCategory.name].sum += +article.sum || 0;

                                    if (uncontrolledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name]) {
                                        uncontrolledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name].sum += +article.sum || 0;
                                    } else {
                                        uncontrolledOperatingExpenses.detailItems[entityCategory.name].detailItems[entityArticle.name] = { name: entityArticle.name, sum: +article.sum || 0 };
                                    }

                                    uncontrolledOperatingExpenses.sum += +article.sum || 0;
                                }

                                if (article.typeMovementCash === 'expenditure' &&taxes && +entityCategory.id === +taxes) {
                                    taxesData.sum += +article.sum || 0;
                                    if (taxesData.detailItems[entityArticle.name]) {
                                        taxesData.detailItems[entityArticle.name].sum += +article.sum || 0;
                                    } else {
                                        taxesData.detailItems[entityArticle.name] = { name: entityArticle.name, sum: article.sum || 0 };
                                    }
                                }

                                if (incasso && +entityCategory.id === +taxes) {
                                    if (article.typeMovementCash === 'expenditure') incassoData.sum -= +article.sum || 0;
                                    if (article.typeMovementCash === 'income') incassoData.sum += +article.sum || 0;
                                    if (incassoData.detailItems[entityArticle.name]) {
                                        if (article.typeMovementCash === 'income') incassoData.detailItems[entityArticle.name].sum += +article.sum || 0;
                                        if (article.typeMovementCash === 'expenditure') incassoData.detailItems[entityArticle.name].sum -= +article.sum || 0;
                                    } else {
                                        let sum = 0;
                                        if (article.typeMovementCash === 'expenditure') sum -= +article.sum || 0;
                                        if (article.typeMovementCash === 'income') sum += +article.sum || 0;
                                        incassoData.detailItems[entityArticle.name] = { name: entityArticle.name, sum };
                                    }
                                }
                            }
                        }
                       
                    }
                }
            })
        }

        totalRevenue.detailItems = {
            'revenue': { ...revenue, divider: totalRevenue.sum || 0 },
            'revenueAgg': { ...revenueAgg, divider: totalRevenue.sum || 0 },
            'otherIncome': { ...otherIncome, divider: totalRevenue.sum || 0 },
        }

        aggCommission.divider = totalRevenue.sum || 0;

        const acquiringTerminalData = { name: 'Расходы на эквайринг (терминалы)', sum: 0, divider: totalRevenue.sum || 0 };
        const acquiringYookassaData = { name: 'Расходы на эквайринг (ЮКасса)', sum: 0, divider: totalRevenue.sum || 0 };
        const otherCommissionAggData = { name: 'Прочие комиссии агрегаторов', sum: 0, divider: totalRevenue.sum || 0 };

        for (const otherExpenditure of otherExpenditures) {
            if (!otherExpenditure.articleId || !otherExpenditure.sum) continue;
            if (acquiringTerminal && +otherExpenditure.articleId === +acquiringTerminal) acquiringTerminalData.sum += +otherExpenditure.sum || 0;
            if (acquiringYookassa && +otherExpenditure.articleId === +acquiringYookassa) acquiringYookassaData.sum += +otherExpenditure.sum || 0;
            if (otherCommissionAgg && +otherExpenditure.articleId === +otherCommissionAgg) otherCommissionAggData.sum += +otherExpenditure.sum || 0; 
            if (banking && +otherExpenditure.articleId === +banking) {
                uncontrolledOperatingExpenses.detailItems['Банковские услуги (РКО)'].sum += +otherExpenditure.sum || 0;
                if (uncontrolledOperatingExpenses.detailItems['Банковские услуги (РКО)'].detailItems[otherExpenditure.articleId]) {
                    uncontrolledOperatingExpenses.detailItems['Банковские услуги (РКО)'].detailItems[otherExpenditure.articleId].sum += +otherExpenditure.sum || 0;
                } else {
                    const entityArticle = articlesExpenditures.find((article) => +article.id === +otherExpenditure.articleId);
                    if (!isEmpty(entityArticle)) uncontrolledOperatingExpenses.detailItems['Банковские услуги (РКО)'].detailItems[otherExpenditure.articleId] = { name: entityArticle.name, sum: +otherExpenditure.sum || 0 };
                }
            }
        }

        const cleanRevenue = { 
            name: 'Чистая выручка', 
            sum: totalRevenue.sum - aggCommission.sum - acquiringTerminalData.sum - acquiringYookassaData.sum - otherCommissionAggData.sum,
            divider: +totalRevenue.sum || 0,
        }

        invoicesPayments.divider = +cleanRevenue.sum || 0;
        controlledOperatingExpenses.divider = +cleanRevenue.sum || 0;
        uncontrolledOperatingExpenses.divider = +cleanRevenue.sum || 0;

        refundSale.divider = +cleanRevenue.sum || 0

        const totalExpenses = { name: 'Итого расходы', sum: (+controlledOperatingExpenses.sum || 0) + (+uncontrolledOperatingExpenses.sum || 0) + (+invoicesPayments.sum || 0) + (+refundSale.sum || 0), divider: +cleanRevenue.sum || 0 };
        const operatingProfit = { name: 'Операционная прибыль', sum: (+cleanRevenue.sum || 0) - (+totalExpenses.sum || 0), divider: +cleanRevenue.sum || 0 };
        taxesData.divider = +cleanRevenue.sum || 0;

        const netProfit = { name: 'Чистая прибыль', sum: (+operatingProfit.sum || 0) - (+taxesData.sum || 0), divider: +cleanRevenue.sum || 0}

        sendData({ revenue, revenueAgg, aggCommission });
        return [
            totalRevenue,
            aggCommission,
            acquiringTerminalData,
            acquiringYookassaData,
            otherCommissionAggData,
            cleanRevenue,
            invoicesPayments,
            controlledOperatingExpenses,
            uncontrolledOperatingExpenses,
            refundSale,
            totalExpenses,
            operatingProfit,
            taxesData,
            netProfit,
            incassoData
        ];
    }

    const onExport = async () => {
        const data = getGroupedData();
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Финансовый ОПиУ');
    
        worksheet.addRow(['Наименование', 'Сумма (руб.)', 'Сумма (%)']);
    
        const addItem = (item, level, divider) => {
            const row = worksheet.addRow([
                item.name || '',
                item.sum || 0,
                (divider > 0) ? calculatePercent(item.sum, divider) : ''
            ]);
            row.outlineLevel = level;
    
            const detailLabel = getDetailLabel(detail);
            const children = detailLabel ? item[detailLabel] || item.detailItems : item.detailItems;
            if (children && typeof children === 'object' && !isEmpty(children)) {
                const childrens = Array.isArray(children) ? children : Object.values(children);
                childrens.forEach((child) => {
                    const childDivider = +divider || +child.divider || 0;
                    addItem(child, level + 1, childDivider);
                });
            }
        };
    
        data.forEach(root => {
            if (root && root.name) addItem(root, 0, root.divider || 0);
        });
    
        worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
            showOutlineSymbols: true
        };
    
        worksheet.eachRow((row) => {
            if (row.outlineLevel !== undefined && row.outlineLevel > 0 && row.model) row.model.collapsed = false;
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
    
        const detailText = [];
        const periodText = `${moment(renderFilters.month).format('MM.YYYY')}`;
        const pointText = (renderFilters.point && renderFilters.point.label) ? renderFilters.point.label : null;
        if (pointText) detailText.push(pointText);
        detailText.push(periodText);
        const resultText = detailText.join(', ');
        link.download = `Финансовый ОПиУ ${resultText}.xlsx`;
        link.click();
    };

    const onRecalculation = () => {
        return swal({
            title: "Перерасчет ОПиУ",
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Подтвердить"],
        }).then(async (approve) => {
            if (approve) {
                actualCommissions.current = false;
                await dispatch(fetchReportIncomeStatement(true));
                force.current = true;
                setReportId(result.id);
            }
        });
        
    }

    const onRecalculationWithCommision = () => {
        return swal({
            title: "Перерасчет ОПиУ",
            text: "Данный перерасчет проигнорирует сохраненную в заказах комиссию агрегаторов и просчетает по актуальным комиссиям",
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Подтвердить"],
        }).then(async (approve) => {
            if (approve) {
                actualCommissions.current = true;
                await dispatch(fetchReportIncomeStatement(true));
                force.current = true;
                setReportId(result.id);
            }
        });
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Финансовый ОПиУ
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: '150px' }}>
                        <label>Месяц *</label>
                        <div style={{ width: '150px' }}>
                            <DatePicker
                                portalId="root-portal"
                                selected={filters.month}
                                onChange={((e) => setFilters('month')(e))}
                                showMonthYearPicker
                                dateFormat="MMMM yyyy"
                                maxDate={new Date(moment().subtract(1, 'month').startOf('month'))}
                                locale="ruNominative"
                                className="form-control"
                                wrapperClassName="react-datepicker-wrapper w-100"
                                showTimeSelect={false}
                            />
                            </div>
                    </div>
                    <div style={{ width: '250px' }}>
                        <label>Филиал *</label>
                        <Select
                            isLoading={pointLoading}
                            isDisabled={pointLoading}
                            closeMenuOnSelect={true}
                            options={points.map((item) => ({ value: item.id, label: renderAdress(item) }))}
                            onChange={((e) => setFilters('point')(e))}
                            placeholder="Филиал"
                            noOptionsMessage={() => 'Нет филиалов'}
                            value={filters.point}
                        />
                    </div>
                    <div style={{ width: '250px' }}>
                        <label>Детализация *</label>
                        <Select
                            isLoading={pointLoading}
                            isDisabled={pointLoading}
                            closeMenuOnSelect={true}
                            options={detailOptions}
                            onChange={setDetail}
                            placeholder="Детализация"
                            noOptionsMessage={() => 'Нет опций'}
                            value={detail}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                        {user.role.id === roleId.admin && renderData() && !isEmpty(result) && result.id &&
                        <>
                        <button disabled={loading} onClick={onRecalculation} className='btn btn-secondary' style={{ marginTop: '1.9rem' }}>Перерасчет</button>
                        <button disabled={loading} onClick={onRecalculationWithCommision} className='btn btn-secondary' style={{ marginTop: '1.9rem' }}>Перерасчет с актуальной комиссией агрегаторов</button>
                        </>
                        }
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                {!isEmpty(result) && result.updated_at && <span className="kt-badge kt-badge--primary kt-badge--inline">{`Отчет сформирован ${moment(result.updated_at).format('DD.MM.YYYY HH:mm:ss')}`}</span>}
            </div>
        );
    }

    const renderTable = () => {
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <span style={{ color: '#000' }}>Наименование</span>
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <span style={{ color: '#000' }}>Сумма (руб.)</span>
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <span style={{ color: '#000' }}>Сумма (%)</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {data.map((item) => item.openable ? <OpenableRow detail={detail} item={item} color='#fff' /> : <ItemRow item={item} color='#fff'/>)}
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if (!isEmpty(result) && renderFilters.point && renderFilters.month) return true;
        if (!orders || orders.length === 0 || !renderFilters.point || !renderFilters.month) return false;
        return true;       
    }

    const renderBody = () => {
        if (loader || loading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="incomeStatement" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}
            </div>
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}